/* eslint-disable */
import React from 'react'
import {Checkbox, message} from 'antd'

import jMoment from 'moment-jalaali'
import http from '../../Component/Interceptor/Interseptor'
import moment from 'moment'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import {Link} from 'react-router-dom'
import cookie from 'react-cookies'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import SortLocal from '../BaseComponent/sortLocal'
import Loader from '../loaders/loader'
import {productShop} from '../../lib/path'
jMoment.loadPersian({dialect: 'persian-modern', usePersianDigits: true})

class ShowRecord extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      sortByProduct: true,
      manualRegVal: null,
      selectedDate: null,
      selectedOption: null,
      providerValue: '',
      providers: [],
      refFactorVal: moment(),
      typeWarehouseId: '',
      isInput: '',
      isInternal: false,
      otherSellers: false,
      refWarehouseId: '',
      id: '',
      code: '',
      quantity: '',
      product: [],
      details: [],
      wareHousesname: [],
      docType: [],
      errorDocForm: '',
      addError: '',
      valueBarcode: 'barcodeOnly',
      fadeTable: 'true',
      visible: false,
      searchesProduct: [],
      search: '',
      searchTablevisibility: false,
      pageNumber: 1,
      lengthProducts: 0,
      docNum: '',
      modal: false,
      preRecordInfo: {},
      array: [],
      errorForm: {
        warehouseName: '',
        isInputError: '',
        warehouseTypeError: ''
      },
      docArr: [],
      allDocTypes: [],
      providerId: '',
      modalError: false,
      unMatchProduct: [],
      errorTextModal: 'آیا از ثبت نهایی پیش سند مطمئن هستید؟؟',
      description: '',
      receiverName: '',
      senderName: '',
      providerName: '',
      refTypeWarehouseName: '',
      manReg: '',
      checked: false,
      typeDocId: '',
      confirmDate: '',
      recorderPerson: '',
      internal: false,
      abnormal: false,
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تامین کننده',
          value: 'providerName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'کدمحصول',
          value: 'articleId',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'بارکد محصول',
          value: 'productCode',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'نام محصول',
          value: 'productName',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'مقدار',
          value: 'quantity',
          sorted: false,
          direction: null,
          sortable: true
        },

        {
          name: 'واحد',
          value: 'unit',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخ تولید',
          value: 'unit',
          sorted: false,
          direction: null,
          sortable: false
        }
      ],
      sort: {},
      printProduct: [],
      parcelId: ''
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  getRefType = (refType) => {
    if (!refType) {
      return ''
    } else {
      if (refType === 'CUSTOMER') return 'مشتری'
      if (refType === 'PROVIDER') return 'فروشنده'
    }
  }

  componentDidMount() {
    let {preWarehouseDocId} = this.props.match.params
    let data = {
      docId: preWarehouseDocId
    }

    this.setState({
      loading: true
    })
    const token = sessionStorage.getItem('accessToken')

    http
      .post(`${WAREHOUSE.WAREHOUSE_DOCUEMNT_GET_DOCUMENT}`, data, {})
      .then((response) => {
        this.setState({
          loading: false,
          preRecordInfo: response.data.object,
          product: this.sortByKey(response.data.object.detailEntities, 'rowNo').map((item) => ({...item})),
          printProduct: this.sortByKey(response.data.object.detailEntities, 'rowNo').map((item) => ({...item})),
          manualReg:
            response.data.object.manualRegisterDate == null ? undefined : response.data.object.manualRegisterDate,
          refFactor: response.data.object.refFactorDate == null ? undefined : response.data.object.refFactorDate,
          isInput: response.data.object.input,
          typeWarehouseId: response.data.object.typeWarehouseId,
          providerId: response.data.object.providerId,
          wareText: response.data.object.typeWarehouseName,
          docTypeText: response.data.object.typeDocName,
          refWareText:
            response.data.object.refTypeWarehouseName == null ? '-' : response.data.object.refTypeWarehouseName,
          proText: response.data.object.providerName,
          description: response.data.object.description,
          receiverName: response.data.object.receiverName,
          senderName: response.data.object.senderName,
          providerName: response.data.object.providerName,
          refTypeWarehouseName: response.data.object.refTypeWarehouseName,
          manReg: response.data.object.manualRegisterDate,
          checked: response.data.object.internal,
          internal: response.data.object.internal,
          refWarehouseId: response.data.object.refTypeWarehouseId,
          typeDocId: response.data.object.typeDocId,
          refFactorNo: response.data.object.refFactorNo,
          confirmDate: jMoment(response.data.object.confirmDate).format('jYY/jMM/jDD'),
          recorderPerson: response.data.object.recorderPerson,
          refType: response.data.object.refType,
          abnormal: response.data.object.abnormal,
          otherSellers: response.data.object.otherSellers,
          parcelId: response.data.object.parcelId
        })

        // alert(this.state.manualRegVal)

        let isInput = this.state.isInput
        var filterWare = this.state.docArr

        const {product} = this.state

        for (let i = 0; i < product.length; i++) {
          let details = {
            id: product[i]['stockProductId'],
            quantity: Number(product[i]['quantity'])
          }
          let detailsArray = []

          detailsArray.push(details)

          this.setState((prevState) => ({
            details: [...prevState.details, details]
          }))
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
      })
  }

  submitForm(e) {
    e.preventDefault()
  }

  onChange = (e) => {
    console.log('radio checked', e.target.isInput)
    this.setState({
      isInput: e.target.value
    })
  }

  changeField(e) {
    const target = e.target
    const value = target.type == 'checkbox' ? target.checked : target.value
    const name = target.name
    this.setState({
      [name]: value,
      id: value
    })
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    })
  }

  handleCancel = (e) => {
    console.log(e)
    this.setState({
      visible: false,
      searchTablevisibility: false,
      searchesProduct: []
    })

    this.setState({
      modal: !this.state.modal
    })
  }

  optionalFields(e) {
    const target = e.target
    const value = target.value
    const name = target.name
    if (!(value == '')) {
      this.setState({
        [name]: value
      })
    } else {
      this.setState({
        [name]: undefined
      })
    }
  }

  epochTo = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()
    return toEpoch
  }

  epochFrom = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()
    return fromEpoch
  }

  confirm() {
    this.setState({
      modalError: !this.state.modalError
    })
  }

  cancelError() {
    this.setState({
      modalError: false
    })
  }

  setFinalyRecord() {
    let {preWarehouseDocId} = this.props.match.params
    let data = {
      docId: preWarehouseDocId
    }

    http
      .post(`${WAREHOUSE.WAREHOUSE_DOCUEMNT_RECORD_DOCUMENT}`, data, {})
      .then((response) => {
        if (!(response.data.object.preDocId == null)) {
          message.success('ثبت پیش سند با موفقیت انجام شد.لطفا صبر کنید')
          this.setState({
            modalError: !this.state.modalError
          })
          setInterval(() => {
            window.location.assign('/PreRecord')
          }, 2000)
        } else {
          message.error('لیست کالا های زیر با تعداد موجودی مغایرت دارد.')
          this.setState({
            modalError: !this.state.modalError,
            unMatchProduct: response.data.object.productLacks
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  sortByKey = (array, key) => {
    return array.sort(function(a, b) {
      var x = a[key]
      var y = b[key]
      return x < y ? -1 : x > y ? 1 : 0
    })
  }

  exportPrint = () => {
    if (this.state.sortByProduct) {
      this.sortPrintByProductName().then((res) => {
        this.printFunc()
      })
    } else {
      this.setState(
        {
          printProduct: this.state.product.map((item) => ({...item}))
        },
        () => {
          this.printFunc()
        }
      )
    }
  }

  printFunc = () => {
    var css = '@page { size:A4 portrait;margin:1mm !important;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  compareBy(key) {
    return function(a, b) {
      if (a[key] < b[key]) {
        return a[key] - b[key]
      } else {
        return b[key] - a[key]
      }
    }
  }

  getSort = (sort) => {
    let arrayCopy = this.state.product
    arrayCopy.sort(this.compareBy(sort.sortColumn))
    this.setState({product: arrayCopy})
  }

  sortPrintByProductName = () => {
    this.setState({
      loading: true
    })
    let {preWarehouseDocId} = this.props.match.params
    let data = {
      docId: preWarehouseDocId,
      sortBy: 'productTitle_asc'
    }
    return http
      .post(`${WAREHOUSE.WAREHOUSE_DOCUEMNT_GET_DOCUMENT}`, data, {})
      .then((res) => {
        this.setState({
          loading: false
        })
        if (res.data.error === null) {
          this.setState({
            printProduct: res.data.object.detailEntities.map((item) => ({...item}))
          })
          return res.data.object.detailEntities
        } else {
          return []
        }
      })
      .catch(() => {
        this.setState({
          loading: false
        })
      })
  }

  showProductNames = (productName, productGenericTitle) => {
    if (productGenericTitle) {
      if (productGenericTitle.trim() === productName.trim()) {
        return <span className="font-weight-bold">{productName}</span>
      } else {
        return (
          <>
            <p className="font-weight-bold">{productName}</p>
            <p className="mb-0 text-dark font-weight-bold">({productGenericTitle})</p>
          </>
        )
      }
    } else {
      return <span>{productName}</span>
    }
  }

  render() {
    const {wareHousesname, preRecordInfo, product} = this.state
    const statusAnbarTaraf = this.state.isInternal == true ? false : true
    const style = product.length == '0' ? 'tableProductWarehouse hide' : 'tableProductWarehouse'

    var initialVal = 0
    var sumProduct = this.state.product.reduce(function(acc, current) {
      return Number(acc) + Number(current.quantity)
    }, initialVal)

    return (
      <div className="rtl sanad">
        <Loader show={this.state.loading} />
        <div className="printDocWrapp printSection">
          <div className="headerDocWrapp">
            <div className="headerDoc">
              <figure className="rightPrintInfo" style={{fontSize: '1.1em'}}>
                <p>
                  <span className="boldPrint">شماره سند :</span>
                  <span className="valuePrint">{this.props.match.params.natureDocNo}</span>
                </p>
                <p>
                  <span className="boldPrint">شماره پیش سند :</span>
                  <span className="valuePrint">{this.props.match.params.preWarehouseDocId}</span>
                </p>

                <p>
                  <span className="boldPrint">تاریخ دستی سند :</span>
                  <span className="valuePrint">
                    {this.state.manualReg == null ? '' : jMoment(this.state.manualReg).format('jYYYY/jMM/jDD')}
                  </span>
                </p>
              </figure>
              <figure className="rightHeaderDoc">
                <img className="printLogoDoc" src={require('../../image/branding/logo-mini.svg')} alt="" />
                <h4>سند {this.state.isInput ? 'وارده' : 'صادره'}</h4>
                <h4>انبار {this.state.wareText}</h4>
                {/*<h4>{this.props.match.params.natureDocNo}</h4>*/}
              </figure>
              <figure className="leftPrintInfo" style={{fontSize: '1.1em'}}>
                <p>کاربر چاپ سند : {cookie.load('name')}</p>
                <p>{'تاریخ چاپ : ' + jMoment().format('jYY/jMM/jDD HH:mm')}</p>
                <p>کاربر ثبت کننده سند : {this.state.recorderPerson}</p>
                <p>
                  <span className="boldPrint">تاریخ ثبت سند :</span>
                  <span className="valuePrint">{this.state.confirmDate}</span>
                </p>
                {/*<p className='pageNumber'> صفحه </p>*/}
              </figure>
            </div>
          </div>
          <div className="bodyDocPrint">
            <div className="itemBodyPrintDoc">
              <figure>
                <p>
                  <span className="boldPrint">نام انبار : </span>
                  <span className="valuePrint">{this.state.wareText}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint">بین انبار : </span>
                  <span className="valuePrint">{this.state.checked ? 'هست' : 'نیست'}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> انبار طرف : </span>
                  <span className="valuePrint">{this.state.refTypeWarehouseName}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> ماهیت : </span>
                  <span className="valuePrint">{this.state.isInput ? 'وارده' : 'صادره'}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> نوع طرف : </span>
                  <span className="valuePrint">{this.getRefType(this.state.refType)}</span>
                </p>
              </figure>
              {this.state.refType === 'CUSTOMER' && !this.state.checked && this.state.parcelId && (
                <figure>
                  <p>
                    <span className="boldPrint">شناسه مرسوله ‌:‌ </span>
                    <span className="valuePrint">{this.state.parcelId}</span>
                  </p>
                </figure>
              )}
              <figure>
                <p>
                  <span className="boldPrint"> تحویل دهنده : </span>
                  <span className="valuePrint">{this.state.senderName}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> تاریخ فاکتور طرف : </span>
                  <span className="valuePrint">
                    {this.state.refFactor == null ? '' : jMoment(this.state.refFactor).format('jYYYY/jMM/jDD')}
                  </span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> تامین کننده : </span>
                  <span className="valuePrint">{this.state.providerName}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> نوع سند : </span>
                  <span className="valuePrint">{this.state.docTypeText}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> تحویل گیرنده : </span>
                  <span className="valuePrint">{this.state.receiverName}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> شماره فاکتور : </span>
                  <span className="valuePrint">{this.state.refFactorNo}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> سند اصلاحی : </span>
                  <span className="valuePrint">{this.state.abnormal ? 'هست' : 'نیست'}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> خرید متفرقه : </span>
                  <span className="valuePrint">{this.state.otherSellers ? 'هست' : 'نیست'}</span>
                </p>
              </figure>
            </div>
            <div className="descriptionDoc">
              <p>توضیحات سند : {this.state.description}</p>
            </div>
          </div>
          <table className="printTable printDocTable">
            <thead>
              <tr>
                <td>
                  <div className="page-header-space" />
                </td>
              </tr>
            </thead>
            <tbody>
              <tr className="firstRow">
                <th>ردیف</th>
                <th>تامین کننده</th>
                <th>کد محصول</th>
                <th>بارکد محصول</th>
                <th>نام محصول</th>
                <th>مقدار</th>
                <th>واحد</th>
                <th>تاریخ تولید</th>
              </tr>
              {this.state.printProduct.map((items, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{items.providerName}</td>
                  <td>{items.articleId}</td>
                  <td>{items.productCode}</td>
                  <td>{this.showProductNames(items.productName, items.productGenericTitle)}</td>
                  <td>{items.quantity}</td>
                  <td>{items.productUnitTitle}</td>
                  <td>{items.manufactureDate}</td>
                </tr>
              ))}
              <tr>
                <td colSpan={5}>جمع اقلام کالا</td>
                <td>{sumProduct}</td>
                <td colSpan={2} />
              </tr>
              <tr>
                <td className="signatureCell" rowSpan={3} colSpan={8}>
                  <div className="signatureDoc">
                    <figure>
                      <p>امضای تحویل دهنده : </p>
                    </figure>
                    <figure>
                      <p>امضای تحویل گیرنده : </p>
                    </figure>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="noPrint container-fluid">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>انبار</li>
            <li>مشاهده سند</li>
          </ul>
          <div className="container-fluid position-relative my-2 p-2 bg-white">
            <div className="card">
              <div className="card-header d-flex flex-row justify-content-between">
                <h5 className="font-weight-bold mb-0">{'شماره سند : ' + this.props.match.params.natureDocNo}</h5>
                <h5 className="font-weight-bold mb-0">
                  <a
                    href={`/ShowPreRecord/${this.props.match.params.preWarehouseDocId}`}
                    target="_blank"
                    className="font-weight-bold mb-0"
                  >
                    {'شماره پیش سند : ' + this.props.match.params.preWarehouseDocId}
                  </a>
                </h5>
              </div>
              <div className="card-body p-3">
                <div className="row">
                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label htmlFor="wareType">انبار</label>
                    <input
                      type="text"
                      disabled={true}
                      tabIndex="5"
                      name="senderName"
                      disabled={true}
                      className="form-control"
                      defaultValue={preRecordInfo.typeWarehouseName}
                    />
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label htmlFor="ماهیت">ماهیت</label>
                    <select className="form-control" id="isInput" disabled={true} name="isInput" tabIndex="2">
                      <option value={true} selected={preRecordInfo.input ? true : false}>
                        وارده
                      </option>
                      <option value={false} selected={!preRecordInfo.input ? true : false}>
                        صادره
                      </option>
                    </select>
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label htmlFor="ماهیت">نوع طرف</label>
                    <select className="form-control" id="refType" disabled={true} name="refType" tabIndex="2">
                      <option selected={!this.state.refType ? true : false} value={null}>
                        ------
                      </option>
                      <option selected={this.state.refType === 'CUSTOMER' ? true : false} value={'CUSTOMER'}>
                        مشتری
                      </option>
                      <option selected={this.state.refType === 'PROVIDER' ? true : false} value={'PROVIDER'}>
                        فروشنده
                      </option>
                    </select>
                  </div>

                  {this.state.refType === 'CUSTOMER' && !this.state.checked && this.state.parcelId && (
                    <div className="col-12 col-md-4 my-2 col-lg-2">
                      <label>شناسه مرسوله</label>
                      <input
                        type="number"
                        disabled
                        defaultValue={this.state.parcelId}
                        name="parcelId"
                        className="form-control"
                      />
                    </div>
                  )}

                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label htmlFor="docType">نوع سند</label>
                    <input
                      type="text"
                      disabled={true}
                      tabIndex="5"
                      name="typeDocId"
                      disabled={true}
                      className="form-control"
                      defaultValue={preRecordInfo.typeDocName}
                    />
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2 d-flex flex-column align-content-center justify-content-center">
                    <label className="hiddenLabel">sd</label>
                    <Checkbox
                      className="form-check"
                      disabled={true}
                      name="isInternal"
                      defaultValue={preRecordInfo.internal ? true : false}
                      checked={this.state.checked}
                      tabIndex="4"
                      defaultChecked={preRecordInfo.internal == true ? true : false}
                      id="isInternal"
                      onChange={this.changeField.bind(this)}
                    >
                      سند بین انبار
                    </Checkbox>
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2 d-flex flex-column align-content-center justify-content-center">
                    <label className="hiddenLabel">sd</label>
                    <Checkbox
                      name="abnormal"
                      tabIndex="4"
                      checked={this.state.abnormal}
                      disabled={true}
                      onChange={this.changeField.bind(this)}
                    >
                      سند اصلاحی
                    </Checkbox>
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2 d-flex flex-column align-content-center justify-content-center">
                    <label className="hiddenLabel">sd</label>
                    <Checkbox name="otherSellers" tabIndex="4" checked={this.state.otherSellers} disabled={true}>
                      خرید متفرقه
                    </Checkbox>
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label>تحویل دهنده</label>
                    <input
                      type="text"
                      disabled={true}
                      onChange={this.optionalFields.bind(this)}
                      tabIndex="5"
                      name="senderName"
                      disabled={true}
                      className="form-control"
                      defaultValue={preRecordInfo.senderName}
                    />
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label>تحویل گیرنده</label>
                    <input
                      type="text"
                      disabled={true}
                      onChange={this.optionalFields.bind(this)}
                      tabIndex="9"
                      name="receiverName"
                      className="form-control"
                      defaultValue={preRecordInfo.receiverName}
                    />
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label>تاریخ دستی سند </label>
                    <input
                      value={this.state.manualReg == null ? '' : jMoment(this.state.manualReg).format('jYYYY/jMM/jDD')}
                      className="form-control"
                      disabled={true}
                    />
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label>تامین کننده</label>
                    <input
                      type="text"
                      disabled={true}
                      tabIndex="5"
                      name="providerName"
                      disabled={true}
                      className="form-control"
                      defaultValue={preRecordInfo.providerName}
                    />
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label htmlFor="">انبار طرف</label>
                    <input
                      type="text"
                      disabled={true}
                      tabIndex="5"
                      name="refWarehouseId"
                      disabled={true}
                      className="form-control"
                      defaultValue={preRecordInfo.refTypeWarehouseName}
                    />
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label>شماره فاکتور</label>
                    <input
                      type="text"
                      onChange={this.optionalFields.bind(this)}
                      disabled={true}
                      tabIndex="11"
                      name="refFactorNo"
                      className="form-control"
                      defaultValue={preRecordInfo.refFactorNo}
                    />
                  </div>
                  <div className="col-12 col-md-4 my-2 col-lg-2">
                    <label>تاریخ فاکتور طرف</label>
                    <input
                      value={this.state.refFactor == null ? '' : jMoment(this.state.refFactor).format('jYYYY/jMM/jDD')}
                      className="form-control"
                      disabled={true}
                    />
                  </div>
                  <div className="col-12">
                    <lable className="mb-1">توضیحات</lable>
                    <input
                      type="text"
                      className="form-control mt-2"
                      style={{height: '40px'}}
                      defaultValue={preRecordInfo.description}
                      id="description"
                      name="description"
                      disabled={true}
                      onChange={this.optionalFields.bind(this)}
                      tabIndex="12"
                    />
                  </div>
                </div>
                <hr />
                <div className="row">
                  <div className="col-12">
                    <div className="mb-3">
                      <Checkbox
                        className=""
                        name="otherSellers"
                        tabIndex="4"
                        checked={this.state.sortByProduct}
                        onChange={() => this.setState({sortByProduct: !this.state.sortByProduct})}
                      >
                        <span className="font-weight-bold text-dark">میخواهم محصولات به ترتیب نام محصول چاپ شود</span>
                      </Checkbox>
                    </div>
                    <table className="baseTable">
                      <tbody>
                        <SortLocal data={this.state.sortData} getSort={this.getSort} />

                        {this.state.product.map((items, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{items.providerName}</td>
                            <td>{items.articleId}</td>
                            <td>{items.productCode}</td>
                            <td className="text-left">
                              <a
                                target="_blank"
                                className="text-decoration-none text-left"
                                href={productShop({articleId: items.articleId})}
                              >
                                {this.showProductNames(items.productName, items.productGenericTitle)}
                              </a>
                            </td>
                            <td>{items.quantity}</td>
                            <td>{items.productUnitTitle}</td>
                            <td>{items.manufactureDate}</td>
                          </tr>
                        ))}
                        <tr>
                          <td colSpan={5}>جمع اقلام کالا</td>
                          <td>{sumProduct}</td>
                          <td colSpan={2} />
                        </tr>
                      </tbody>
                    </table>
                    <div
                      style={{bottom: 10, right: 10}}
                      className="d-flex position-sticky mt-3 flex-row align-content-center align-item-center"
                    >
                      <button className="btn mx-0 my-0 btn-primary btn-sm" onClick={this.exportPrint}>
                        چاپ
                        <i className="fas fa-print align-middle mx-1" />
                      </button>
                    </div>
                  </div>
                  {this.state.unMatchProduct.length > 0 && (
                    <div className="col-12">
                      <div className="unmatchTable">
                        <p className="errorText mb-0">لیست کالاهای مغایر</p>
                        <table className="baseTable unmatchTable">
                          <tbody>
                            <tr className="firstRow">
                              <td>ردیف</td>
                              <td>کد محصول</td>
                              <td>نام محصول</td>
                              <td>تعداد درخواست شده</td>
                              <td>تعداد باقی مانده</td>
                            </tr>
                            {this.state.unMatchProduct.map((product, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{product.productId}</td>
                                <td>{product.productTitle}</td>
                                <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                                  {product.requestedQuantity}
                                </td>
                                <td style={{fontSize: '1.2em'}} className="font-weight-bolder">
                                  {product.remainQuantity}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ShowRecord
